<template>
  <UIButton
    :disabled="disabled"
    size="small"
    use="primary"
    @click="$emit('click')"
    class="ml-4"
    :class="{
      'cursor-not-allowed': disabled,
      'bg-curious-blue-500 text-white hover:bg-curious-blue-400': !disabled,
    }"
  >
    <span>{{ $t(label) }} </span
    ><UISpinner v-if="loading" class="absolute"></UISpinner
  ></UIButton>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { UIButton, UISpinner } from '@gohighlevel/ghl-canvas'

export default defineComponent({
  components: { UIButton, UISpinner },
  emits: ['click'],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: { type: Boolean, required: false, default: false },
    label: { type: String, required: false, default: 'common.restoreVersion' },
  },
  setup(props, { emit }) {
    return {}
  },
})
</script>

<style scoped></style>
